import { FC } from 'react';
import { useTranslate } from 'hooks/useTranslate';

const ReclassificationOperationTableHeader: FC = () => {
  const { t } = useTranslate();

  return (
    <thead>
      <tr className="nk-tb-item tb-tnx-head">
        <th className="nk-tb-col text-left">{t('Partner')}</th>

        <th className="nk-tb-col text-center tb-col-md">{t('From')}</th>

        <th className="nk-tb-col text-center tb-col-md">{t('To')}</th>

        <th className="nk-tb-col text-left tb-col-md">{t('Class')}</th>

        <th className="nk-tb-col text-center tb-col-md">{t('NewFrom')}</th>

        <th className="nk-tb-col text-center tb-col-md">{t('NewTo')}</th>

        <th className="nk-tb-col text-left">{t('NewClass')}</th>
      </tr>
    </thead>
  );
};

export default ReclassificationOperationTableHeader;
